/**
 * Mirrors packages/amgroulette_v2/lib/core/constants/api_constants.dart
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

export const GAME_KEY_SINGLE = 'RLA1';
export const GAME_KEY_MULTI = 'RLAM';
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/roulettehub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_roulette_v2/web/index.html */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

export const DEFAULT_USER_NAME = 'user2';
export const DEFAULT_PASSWORD = '123456';

/** Default game config — used until /action/getinfo overrides. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 1000,
  maxBet: 100000,
  chipValues: [1000, 5000, 10000, 50000, 100000, 500000] as const,
};

/**
 * Wheel-spin sequence timing (driven by the Rive state machine — these are
 * safety-net fallbacks for when the .riv build doesn't emit evtBallStop /
 * evtResultStop).
 */
export const WHEEL_SPIN_FALLBACK_MS = 8000;
export const RESULT_STOP_FALLBACK_MS = 4000;
